export const getValueFromContent = (value, content, defaultValue) => {
  const findPatternResult = /^{{(.+)}}$/.exec(value);

  if (findPatternResult) {
    const key = findPatternResult[1];
    return content[key] || value;
  } else if (!value) {
    return defaultValue;
  }

  return value;
};
